import React, { Component, Fragment } from "react";
import RcTooltip from "rc-tooltip";
import Classnames from "classnames";
import { observer } from "mobx-react";
import PropTypes from "prop-types";

import { LINK } from "@/utils/getting";
import { IsEmptyObject } from "@/utils/setting";
import Store from "@/stores";

class SkillTips extends Component {
	static propTypes = {
		rune: PropTypes.object,
		skill: PropTypes.object
	}
	static defaultProps = {
		rune: {},
		skill: {}
	}
	render() {
		const { rune, skill } = this.props;
		const active = IsEmptyObject(skill)
			? null
			: (
				<div className="content">
					{skill.icon && <img src={`${LINK.skill}/${skill.icon}.png`} />}
					<div dangerouslySetInnerHTML={{ __html: skill.descriptionHtml }} />
					<small>于<em>{skill.level}</em>级解锁</small>
				</div>
			);
		const passive = IsEmptyObject(rune)
			? null
			: (
				<div className="content">
					{rune.type && <i className={`rune-${rune.type}`} />}
					<h4>{rune.name}</h4>
					<div dangerouslySetInnerHTML={{ __html: rune.descriptionHtml }} />
					<small>于<em>{rune.level}</em>级解锁</small>
				</div>
			);
		return (
			<Fragment>
				<h3>{skill.name}</h3>
				{active}
				{passive}
			</Fragment>
		);
	}
}

class SkillItem extends Component {
	static propTypes = {
		index: PropTypes.number,
		mode: PropTypes.string,
		rune: PropTypes.object,
		skill: PropTypes.object
	}
	static defaultProps = {
		index: 0,
		mode: "active",
		rune: {},
		skill: {}
	}
	render() {
		const { index, mode, rune, skill } = this.props;
		const item = (
			<div className={Classnames(`icon ${mode}`, { empty: !skill.icon })}>
				{mode === "active" && index === 0 && <i className="left-click" />}
				{mode === "active" && index === 1 && <i className="right-click" />}
				{mode === "active" && index > 1 && <i className="key-num">{index - 1}</i>}
				{skill.icon && <img src={`${LINK.skill}/${skill.icon}.png`} />}
			</div>
		);
		const tooltipItem = (
			<RcTooltip
				destroyTooltipOnHide={true}
				overlay={<SkillTips rune={rune} skill={skill} />}
				overlayClassName="ladder-skill-tips"
				placement="rightBottom"
			>
				{item}
			</RcTooltip>
		);
		return (
			<li className={Classnames("ladder-skill-item", { single: IsEmptyObject(rune) })}>
				{(!IsEmptyObject(rune) || !IsEmptyObject(skill)) ? tooltipItem : item}
				<h4 className="ellipsis">{skill.name}</h4>
				{rune && <p className="ellipsis">{rune.name}</p>}
			</li>
		);
	}
}

@observer
class Skill extends Component {
	render() {
		let { active, passive } = Store._ladderStore.hero.skills;
		active = active.length >= 6 ? active : active.concat([...Array(6 - active.length)].map(() => ({})));
		passive = passive.length >= 4 ? passive : passive.concat([...Array(4 - passive.length)].map(() => ({})));
		const activeList = active.map((v, i) => <SkillItem key={i} {...Object.assign({}, v, { index: i })} />);
		const passiveList = passive.concat().map((v, i) => <SkillItem key={i} mode="passive" {...v} />);
		return (
			<div className="ladder-skill fr">
				<h3>技能</h3>
				<ul className="clearfix">{activeList}</ul>
				<ul className="clearfix">{passiveList}</ul>
			</div>
		);
	}
}
export default Skill;